import { PRINCIPLES } from "@/mocks/reportData";

const QUOTES = [
  {
    text: "匿名投了材料，后来报道做了深度跟进，整个过程没有任何人联系到我的身份信息，这点让我很安心。",
    who: "匿名线索人 · 某制造业从业者",
  },
  {
    text: "报道没有简单站队，而是把前因后果摆出来让读者判断，这种克制在当前很难得。",
    who: "长期读者 · 关注社会议题",
  },
  {
    text: "我补充过两次私信线索，对方核实得很细，被引用的部分也会跟我确认口径，感觉是真的在做事。",
    who: "匿名线索人 · 教育行业",
  },
];

export default function Principles() {
  return (
    <section id="principles" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">WHO WE ARE</span>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            一条线索的旅程，从匿名开始
          </h2>
          <p className="mt-3 text-[15px] leading-7 text-foreground-700">
            我们是一群相信“小事被听见，问题才可能被解决”的人。每条报道背后，都是一次从匿名走向公开的认真尝试。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {PRINCIPLES.map((p) => (
            <div
              key={p.title}
              className="rounded-lg bg-background-100 p-5 text-center ring-1 ring-background-200"
            >
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-3 font-display text-base font-bold text-foreground-900">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* credibility */}
        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {QUOTES.map((q, i) => (
            <figure
              key={q.who}
              className="rounded-lg bg-background-100 p-6 ring-1 ring-background-200"
            >
              <i className="ri-double-quotes-l text-3xl text-secondary-300" aria-hidden="true"></i>
              <blockquote className="mt-3 text-sm leading-7 text-foreground-800">{q.text}</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                  <i className="ri-user-smile-line text-base" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">真实用户反馈</p>
                  <p className="text-xs text-foreground-500">线索编号 #0{i + 1} · {q.who}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}